import { render, staticRenderFns } from "./Alibaba-buyer.vue?vue&type=template&id=7f5d9240&"
import script from "./Alibaba-buyer.vue?vue&type=script&lang=js&"
export * from "./Alibaba-buyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports